import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    semestral: true,

    id: 0,
    fechaVigenciaDesde: moment(new Date()).format('YYYY-MM-DD'),
    fechaVigenciaHasta: moment(new Date()).format('YYYY-MM-DD'),
    indicadorSemestre: null,
    indicadorSemestreNombre: null,
    indicadorAnio: null,
    pjeObjetivo: 0,
    descripcion: '',
    rowVersion: null,

    /* Indicador anterior */
    fechaVigenciaDesdeAnterior: '1900-01-01',
    fechaVigenciaHastaAnterior: '1900-01-01',
    indicadorPeriodoAnterior: '',
    pjeObjetivoAnterior: 0,
    pjeRentabilidadAnterior: 0,

    indicadorDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, params) {
        state.semestral = params.semestral;

        state.id = params.indicadorId;
        state.fechaVigenciaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.indicadorSemestre = null;
        state.indicadorSemestreNombre = null;
        state.indicadorAnio = null;
        state.pjeObjetivo = 0;
        state.descripcion = '';
        state.rowVersion = null;
    },
    'SET_INDICADOR'(state, indicador) {
        state.fechaVigenciaDesde = moment(indicador.fechaVigenciaDesde).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(indicador.fechaVigenciaHasta).format('YYYY-MM-DD');
        if ((/true/i).test(state.semestral)) {
            state.indicadorSemestre = indicador.indicadorSemestre;
            state.indicadorSemestreNombre = indicador.indicadorSemestre == 1 ? '1er Semestre' : '2do Semestre';
        }
        state.indicadorAnio = indicador.indicadorAnio;
        state.pjeObjetivo = indicador.pjeObjetivo;
        state.descripcion = indicador.descripcion.trim();
        state.rowVersion = indicador.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.indicadorDatos = [];
    },
    'SET_DATOS' (state, indicadorDatos) {
        state.indicadorDatos = indicadorDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            if (params.indicadorId != 0) {
                let url = 'indicadores-rentabilidad-neta';
                if ((/true/i).test(params.semestral)) {
                    url += '/semestral/';
                } else {
                    url += '/anual/';
                }
    
                apiAxios.get(url + params.indicadorId + '/abm' ) 
                    .then(res => {
                        commit('SET_INDICADOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let indicador = {
                fechaVigenciaDesde: moment(state.fechaVigenciaDesde).format('YYYY-MM-DD'),
                fechaVigenciaHasta: moment(state.fechaVigenciaHasta).format('YYYY-MM-DD'),
                indicadorAnio: state.indicadorAnio,
                pjeObjetivo: parseFloat(state.pjeObjetivo),
                descripcion: state.descripcion.trim(),
            }

            if ((/true/i).test(state.semestral)) {
                if (state.indicadorSemestreNombre.trim() == '1er Semestre') {
                    indicador.indicadorSemestre= 1;
                }
                if (state.indicadorSemestreNombre.trim() == '2do Semestre') {
                    indicador.indicadorSemestre= 2;
                }
            }

            let url = 'indicadores-rentabilidad-neta';

            if ((/true/i).test(state.semestral)) {
                url += '/semestral';
            } else {
                url += '/anual';
            }
            
            if (state.id != 0) {
                url += '/' + state.id;
                indicador.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, indicador)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (params.indicadorId != 0) {
                let url = 'indicadores-rentabilidad-neta';

                if ((/true/i).test(params.semestral)) {
                    url += '/semestral/';
                } else {
                    url += '/anual/';
                }

                apiAxios.get(url + params.indicadorId ) 
                .then(res => {
                    let datos = [
                        { 'nombre': 'indicadorAnio', 'campo': 'Año', 'valor': res.data.indicadorAnio, 'formato': '' }
                    ];

                    if ((/true/i).test(params.semestral)) {
                        datos.push(
                            { 'nombre': 'indicadorSemestre', 'campo': 'Semestre', 'valor': res.data.indicadorSemestre == 1 ? '1er Semestre' : '2do Semestre', 'formato': '' }
                        )
                    }

                    datos.push(
                        { 'nombre': 'fechaVigenciaDesde', 'campo': 'Fecha Vigencia - Desde', 'valor': res.data.fechaVigenciaDesde, 'formato': 'fecha' },
                        { 'nombre': 'fechaVigenciaHasta', 'campo': 'Fecha Vigencia - Hasta', 'valor': res.data.fechaVigenciaHasta, 'formato': 'fecha' },
                        { 'nombre': 'pjeObjetivo', 'campo': 'Pje.Objetivo', 'valor': res.data.pjeObjetivo, 'formato': 'numero' },
                        { 'nombre': 'descripcion', 'campo': 'Descripcion', 'valor': res.data.descripcion.trim(), 'formato': '' }
                    )
                    
                    commit('SET_DATOS', datos);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}